// Central asset URLs
export const ASSETS = {
  logo: "https://customer-assets-lqy194kg.emergentagent.net/job_mama-connect-preview/artifacts/cxzzk5ly_FD164A30-A5DC-4F91-91E1-E4B51BC455D3.webp",
  screenshots: {
    onboarding:
      "https://customer-assets-lqy194kg.emergentagent.net/job_mama-connect-preview/artifacts/iukgk9kt_IMG_1155.webp",
    swipe:
      "https://customer-assets-lqy194kg.emergentagent.net/job_mama-connect-preview/artifacts/62edbgkp_IMG_1164.webp",
    chat:
      "https://customer-assets-lqy194kg.emergentagent.net/job_mama-connect-preview/artifacts/5gkn2t7k_IMG_1168.webp",
    events:
      "https://customer-assets-lqy194kg.emergentagent.net/job_mama-connect-preview/artifacts/hgapwfap_IMG_1162.webp",
  },
  testimonials: [
    "https://images.pexels.com/photos/10935456/pexels-photo-10935456.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/27176616/pexels-photo-27176616.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
    "https://images.pexels.com/photos/18689091/pexels-photo-18689091.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  ],
};
